// extracted by mini-css-extract-plugin
export var centredContent = "testimonials-module--centredContent--voe96";
export var container = "testimonials-module--container--g181q";
export var h4 = "testimonials-module--h4--8a1Fl";
export var h5 = "testimonials-module--h5--g8MRq";
export var logo = "testimonials-module--logo--QboOq";
export var pinkBack = "testimonials-module--pinkBack--K6ac7";
export var quoteIcon = "testimonials-module--quoteIcon--unnJ1";
export var quoteIconRotated = "testimonials-module--quoteIconRotated--XK8pJ";
export var signatureWrapper = "testimonials-module--signatureWrapper--COet+";
export var testimonialsWrapper = "testimonials-module--testimonialsWrapper--5j5hd";